import additionalPrice, { additionalPriceNames } from '@constants/values/additionalPriceAdd'
const cenaDodatkowe = { name: 'cena-wartosci-dodatkowe', options: additionalPrice, names: additionalPriceNames }
export default cenaDodatkowe